import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/dropdown'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    config: {
      defaultValue: null,
      defaultValueBehaviour: 'first',
      validators: ['mandatoryDropdown'],
    },
  };
}
